module.exports = __webpack_public_path__ + "media/images/pic/saska/team-hero-c722a9119f76b22d52e5ed427927ae3d.jpg";